import { PublicKey } from "@solana/web3.js";
import { getAssociatedTokenAddress, getAccount, getAssociatedTokenAddressSync } from "@solana/spl-token";
import { getProvider } from "./conn";
import { lamportsToSol } from "./utils";

export const checkIfWalletConnected = async () => {
  const { solana } = window;
  return new Promise(async (resolve, reject) => {
    try {
      // setLoading(true);
      if (solana && solana.isPhantom) {
        const response = await solana.connect({
          onlyIfTrusted: true,
        });
        resolve(response.publicKey.toString());
        console.log("public key", response.publicKey.toString());
      } else {
        resolve("");
      }
    } catch (err) {
      console.log("errror");
      resolve("");
    }
  });
};

export const connectWallet = async () => {
  const { solana } = window;
  return new Promise(async (resolve, reject) => {
    try {
      // setLoading(true);
      if (solana) {
        const response = await solana.connect(); //to disconnect use "solana.disconnect()"
        resolve(response.publicKey.toString());
        // setWalletAdresss(response.publicKey.toString());

        // initUserAccount();
      } else {
        alert("Please Install Solana's Phantom Wallet");
        resolve("");
      }
    } catch (err) {
      resolve("");
      console.log(err);
    }
  });
};

export const getSSMTokenBalance = async () => {
  console.log("getSSMTokenBalance");
  const provider = getProvider();
  //@ts-ignore
  if (!provider.publicKey) {
    return "";
  }

  // get the associated token account for the user
  const associatedTokenAccount = getAssociatedTokenAddressSync(
    new PublicKey("Bre6EkdRj2ZtRCcqGoLXCWYebpTub3DxqPvYhZV7moon"),
    provider.publicKey,
  );

  try {
    // get the balance of the associated token account
    const balance = await getAccount(provider.connection, associatedTokenAccount).then((data) => {
      return lamportsToSol(Number(data.amount));
    });

    return balance;
  } catch (error) {
    if (error instanceof Error && error.name === "TokenAccountNotFoundError") {
      console.log("Token account not found");
      return 0;
    } else {
      throw error;
    }
  }
};

export const getBalance = async () => {
  const provider = getProvider();
  //@ts-ignore
  if (!provider.publicKey) {
    return { balance: "", winBalance: "" };
  }
    
  let jackpotBalance = await provider.connection
  .getBalance(new PublicKey("9qBvHH7xMs2bKS8kbKnkzr4uPT2i4uFgtRxLh9c4McUm"))
  .then(function (data) {
    console.log("Wallet balance: " + lamportsToSol(data).toFixed(2));
    return lamportsToSol(data).toFixed(2);
  })
  .catch(function (error) {
    console.log(error);
    return "";
  });
    
  let balance = await provider.connection
  .getBalance(provider.publicKey)
  .then(function (data) {
    console.log("Wallet balance: " + lamportsToSol(data).toFixed(2));
    return lamportsToSol(data).toFixed(2);
  })
  .catch(function (error) {
    console.log(error);
    return "";
  });

  const ssmBalance = await getSSMTokenBalance();

  return { balance, jackpotBalance, ssmBalance };
}
